import { createApi } from '@reduxjs/toolkit/query/react';
import axiosFetchBase from '../axiosFetchBase';
import { urls } from '../../utils/helpers/ApiClient';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: urls.login,
        method: 'POST',
        data: credentials,
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: urls.logout,
        method: 'POST',
      }),
    }),
    refresh: builder.mutation({
      query: () => ({
        url: urls.refresh,
        method: 'POST',
      }),
    }),
    getLoggedUser: builder.query({
      query: () => ({
        url: urls.getUser,
        method: 'GET',
      }),
    }),
    impersonate: builder.mutation({
      query: ({ id, type }) => ({
        url: urls.impersonate(id),
        method: 'POST',
        data: { type },
      }),
    }),
    leaveImpersonation: builder.mutation({
      query: () => ({
        url: urls.leaveImpersonation,
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useRefreshMutation,
  useGetLoggedUserQuery,
  useImpersonateMutation,
  useLeaveImpersonationMutation,
} = authApi;
